export default __webpack_public_path__ + "static/media/map.5fb202fb.png";